module.exports = __webpack_public_path__ + "static/media/logo-black.7105329a.png";